import { Directive, HostListener, input } from '@angular/core';

export type DsButtonVariant = 'primary' | 'secondary' | 'quiet' | 'danger';
export type DsButtonSize = 'small' | 'medium' | 'large';

@Directive({
  selector: 'button[dsButton], a[dsButton]',
  host: {
    class: 'ds-button',
    '[class.ds-button--primary]': "variant() === 'primary'",
    '[class.ds-button--secondary]': "variant() === 'secondary'",
    '[class.ds-button--quiet]': "variant() === 'quiet'",
    '[class.ds-button--danger]': "variant() === 'danger'",
    '[class.ds-button--small]': "size() === 'small'",
    '[class.ds-button--large]': "size() === 'large'",
    '[class.ds-button--loading]': 'loading()',
    '[attr.aria-busy]': "loading() ? 'true' : null",
    '[attr.aria-disabled]': "loading() ? 'true' : null",
  },
})
export class DsButtonDirective {
  readonly variant = input<DsButtonVariant>('primary');
  readonly size = input<DsButtonSize>('medium');
  readonly loading = input(false);

  @HostListener('click', ['$event'])
  protectLoading(event: Event): void {
    if (!this.loading()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
